<template>
  <div id="budgetCustomization">
    <div class="search-list">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="任务标题">
          <el-date-picker
            v-model="value2"
            type="month"
            placeholder="选择月"
            size="mini"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit" size="mini">查询</el-button>
          <el-button type="info" @click="onSubmit" size="mini">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table">
      <el-table
        :data="tableLists"
        row-key="id"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="date"
          label="姓名"
          width="180"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="users"
          label="奖扣内容"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="count"
          label="积分"
          width="100"
          align="center"
        >
        </el-table-column>
        <!-- <el-table-column
          prop="bm"
          label="隶属部门"
        >
        </el-table-column> -->
        <el-table-column
          prop="da"
          label="时间"
          width="100"
          align="center"
        >
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref, watch, getCurrentInstance, nextTick } from '@vue/composition-api'
export default {
  name: 'BudgetCustomization',
  props: [

  ],
  setup (props, ctx) {
    let tableLists = [{
      id: 1,
      date: '芳芳',
      users: '每天仔细检查没意见客房间,保证房间卫生,设备正常使用,加100/分',
      address: '上海市普陀区金沙江路 1518 弄',
      syb: '大内容事业部',
      bm: '技术研发部',
      count: 2000,
      da: '2022-06-04'
    },
    {
      id: 2,
      date: '佳佳',
      users: '拾金不昧,根据金额大小定价值,加5-100分',
      address: '上海市普陀区金沙江路 1518 弄',
      syb: '数字营销事业部',
      bm: '产品部',
      count: 200,
      da: '2022-06-04'
    }, {
      id: 3,
      date: '看板',
      users: '有效创新,加10分/项',
      address: '上海市普陀区金沙江路 1518 弄',
      syb: '财务部',
      bm: 'IT部',
      count: 1000,
      da: '2022-06-04'
    }]

    return { tableLists
    }
  },
  components: {

  }
}
</script>

<style scoped lang="stylus">

.word-nowrap-text
  white-space nowrap
  overflow: hidden
  text-overflow: ellipsis
</style>
